import { Injectable } from "@angular/core";
import { DefaultSelection36PhasePayload } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalPhaseService extends BaseService<DefaultSelection36PhasePayload> {}
